import { render, staticRenderFns } from "./BrowserLoader.vue?vue&type=template&id=c1e53b9c&scoped=true"
import script from "./BrowserLoader.vue?vue&type=script&lang=js"
export * from "./BrowserLoader.vue?vue&type=script&lang=js"
import style0 from "./BrowserLoader.vue?vue&type=style&index=0&id=c1e53b9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e53b9c",
  null
  
)

export default component.exports